"use strict"

import { loadCartProducts } from "./cart/loadCart";
import { loadCheckoutForm } from "./cart/loadCheckout";
import { Cart, updateCartInHeader } from "./Classes/Cart";
import { loadExpertForm } from "./expertform/expertform";
import { initClickableAmountInput } from "./forms/amountInput";
import { sendRequestModule } from "./modules/sendRequestModule";
import {loadProductConfigurator} from "./productConfigurator/productConfigurator";







(function ($) {

    document.addEventListener("DOMContentLoaded", () => {

        initClickableAmountInput();
        saveCssVarsToRoot();


        let cart = new Cart();
        let currentSavedCart = cart.getCartFromLocalStorage();
        if(currentSavedCart) {
            cart.updateCompleteCartWithNewProducts(currentSavedCart.products)
        }
        console.log(cart)      

        updateCartInHeader(cart);

        
        

        let productConfigHolder = document.querySelector(".product-configurator");
        if(productConfigHolder) {
            loadProductConfigurator(cart);
        }

        let cartProductsHolder = document.querySelector(".cart-products");
        if(cartProductsHolder) {
            loadCartProducts(cart);
        }


        let checkoutHolder = document.getElementById("checkout-holder");
        if(checkoutHolder) {
            loadCheckoutForm(cart);
        }

        let expertCart = document.getElementById("expert-form")
        if(expertCart) {
            loadExpertForm(expertCart, cart)
        }





    })





})(jQuery)




function saveCssVarsToRoot() {
    let vh = window.innerHeight * 0.01;
    let headerHeight = document.querySelector("header").offsetHeight;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty('--headerHeight', `${headerHeight}px`);
}
